var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA2ManualMultiwireDiagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#A2_Manual_Multiwire_Diagram_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58 42h4v23H0V30.22L13.57 16H54v4H15v12H4v29h54V42zM41 57v-7.81l-8.14-6.8-2.56 3.07 6.7 5.6V57h4zm34.34-35.87l-.06.06a.573.573 0 01-.11.11l-.14.14-16 16.19-.07.07L47 40.85l3.48-11.71 16.25-16.28.27-.28c1.77-1.65 5-1 7.21 1.44s2.59 5.39 1.13 7.11zM56.33 35l-3.48-3.48-1.4 3.58 1.41 1.22L56.33 35zm15.28-16.51l-2.11-2.13-2.5 2.52-10.16 10L58.9 31 69 21l2.61-2.51zM27 57v-7.81l-8.14-6.8-2.56 3.07 6.7 5.6V57h4zm14-25h5v-4H18v4h5v9h4v-9h10v9h4v-9z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "A2_Manual_Multiwire_Diagram_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h76v76H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/A2_Manual_Multiwire_Diagram.67c75f8a.svg";
export { SvgA2ManualMultiwireDiagram as ReactComponent };